export default "__VITE_ASSET__BbtelEhG__"